import React from "react";
import { Permission } from "../../context/UserContext";
import { usePermissions } from "../../hooks/usePermissions";
import { ErrorMessage } from "../ErrorMessage/ErrorMessage";
import { PageContent } from "../PageContent/PageContent";

const INSUFFICIENT_PERMISSIONS_MESSAGE =
  "You have insufficient permissions to access this page.";

/**
 * Renders children only when the signed-in user holds the given permission.
 * Otherwise shows an insufficient-permissions error (same ErrorMessage pattern
 * as RolesErrorBanner). Children are not mounted when the check fails.
 */
export const RequirePermission = ({
  permission,
  children,
}: {
  permission: Permission;
  children: React.ReactNode;
}) => {
  const [hasPermission] = usePermissions(permission);

  if (!hasPermission) {
    return (
      <PageContent>
        <ErrorMessage>{INSUFFICIENT_PERMISSIONS_MESSAGE}</ErrorMessage>
      </PageContent>
    );
  }

  return <>{children}</>;
};
